/* eslint-disable @typescript-eslint/no-explicit-any */
import { RaceTable } from 'features/Race/components'
import { guildVaultTableCoinColumns } from 'utils/columns'
import { useAppDispatch, useAppSelector, useUpdateEffect } from 'hooks'
import React, { memo, useEffect, useMemo, useState } from 'react'
import { GetRaceListParams } from 'models'
import { NUMBER, STRING } from 'apps/constants'
import { NOTIFICATION_MESSAGE } from 'i18n/constants'
import { useTranslation } from 'react-i18next'
import { notification } from 'antd'
import { getCoinList } from 'apps/redux/userCreateRace/action'
import { useSelector } from 'react-redux'
import { errorCoinListTable, getCoinListTable } from 'apps/redux/userCreateRace/selector'
import { GAME_TOKEN_KUDA, GAME_TOKEN_MERAH, ICON_ADIL } from 'assets/images'

const defaultParams: GetRaceListParams = {
  limit: NUMBER.TWENTY,
  page: NUMBER.ONE
}

function TableCoin() {
  const [api, contextHolder] = notification.useNotification()
  const { t } = useTranslation()
  const { profile } = useAppSelector(state => state)
  const [dataTable, setDataTable] = useState<any>([])
  const [params, setParams] = useState<GetRaceListParams>(defaultParams)
  const [loading, setLoading] = useState<boolean>(false)
  const dispatch = useAppDispatch()
  const [total, setTotal] = useState()
  const dataCoinTable = useSelector(getCoinListTable)
  const errorCoin = useSelector(errorCoinListTable)

  const memoizedResultListSelectionColumns = useMemo(() => {
    return guildVaultTableCoinColumns
  }, [profile])

  useEffect(() => {
    if (profile.guild_id !== NUMBER.ZERO) {
      setLoading(true)
      getListDataTable()
    }
  }, [params, profile.guild_id])

  useEffect(() => {
    if (errorCoin) {
      openNotification(STRING.ERROR, errorCoin)
    }
  }, [errorCoin])

  useEffect(() => {
    if (dataCoinTable?.records) {
      setLoading(false)
      const getAvatarByType = (type: string) => {
        switch (type) {
          case 'ADIL':
            return ICON_ADIL
          case 'KUDA_NEW':
            return GAME_TOKEN_KUDA
          case 'MERAH_NEW':
            return GAME_TOKEN_MERAH
          default:
            return ''
        }
      }
      const formatData = dataCoinTable?.records.map((record: any) => {
        return {
          ...record,
          coin_type: record.coin_type?.replace('_NEW', ''),
          avatar: getAvatarByType(record.coin_type)
        }
      })
      setDataTable(params.page > NUMBER.ONE ? [...dataTable, ...formatData] : formatData)
      setTotal(dataCoinTable?.total || NUMBER.ZERO)
    }
  }, [dataCoinTable])

  const openNotification = (message: string, description: string) => {
    notification.config({
      duration: NUMBER.FOUR
    })

    api.info({
      message,
      description,
      placement: 'bottomRight',
      className: message === STRING.ERROR ? 'ant-custom-error' : 'ant-custom-success'
    })
  }

  const getListDataTable = async () => {
    dispatch(getCoinList({ guildId: profile.guild_id, params }))
  }

  useUpdateEffect(() => {
    setParams({ ...params, page: NUMBER.ONE })
  }, [])

  return (
    <div>
      {contextHolder}
      <RaceTable
        columns={memoizedResultListSelectionColumns}
        data={dataTable}
        raisePage={setParams}
        loader={!loading}
        params={params}
        checkLoadingPage={false}
        totalRace={total}
        currentUser={profile}
        noDataText={t(`${NOTIFICATION_MESSAGE}.dataNotFound`)}
        isShowVipIcon={true}
      />
    </div>
  )
}

export default memo(TableCoin)
